import { render, staticRenderFns } from "./TabHistoryDetail.vue?vue&type=template&id=bbcc1696&scoped=true"
import script from "./TabHistoryDetail.vue?vue&type=script&lang=js"
export * from "./TabHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./TabHistoryDetail.vue?vue&type=style&index=0&id=bbcc1696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcc1696",
  null
  
)

export default component.exports